import React, { useState, useEffect } from "react";
import "./NewMatchesCard.css";
import PlaceIcon from "@mui/icons-material/Place";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../BASE_URL";

const NewMatchesCard = ({ data }) => {
  const navigate = useNavigate();
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [ids, setIds] = useState([]);

  useEffect(() => {
    FetchDataSentRequest();
  }, []);

  useEffect(() => {
    // Check if current user ID exists in sent requests
    setIsRequestSent(ids.includes(data._id));
  }, [ids, data._id]);

  const FetchDataSentRequest = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/request/pending`, {
        method: "GET",
        headers: {
          Authorization: localStorage.getItem("saptvidhiUserToken"),
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        const extractedIds = responseData.data[0]?.sent.map((item) => item._id) || [];
        setIds(extractedIds);
      }
    } catch (error) {
      console.error("Error fetching sent requests:", error);
    }
  };

  const SendRequest = async () => {
    if (isRequestSent) return;

    try {
      const response = await fetch(`${BASE_URL}/api/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("saptvidhiUserToken"),
        },
        body: JSON.stringify({
          receiver_id: data._id,
          request_status: "pending",
          request_type: "request",
        }),
      });

      if (response.status === 200) {
        setIsRequestSent(true);
        toast.success('Request Sent Successfully!', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
        setIds(prev => [...prev, data._id]); // Update local state
      } else if (response.status === 403) {
        setIsRequestSent(true);
        toast.info('Request was already sent previously', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (error) {
      toast.error('Failed to Send Request', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
    }
  };

  const handleProfileClick = () => {
    navigate(`/userprofile/${data._id}`, { state: { status: "pending" } });
  };

  return (
    <div className="newmatchescard">
      <div className="newmatchescard_location align-items-center">
        <PlaceIcon />
        <h4 className="mb-0">{data.home_town}</h4>
      </div>
      <img
        src={data.profile_photo}
        style={{ cursor: "pointer" }}
        alt="Profile"
        onClick={handleProfileClick}
      />
      <div
        className="newmatchescard_intro"
        style={{ cursor: "pointer" }}
        onClick={handleProfileClick}
      >
        <p>
          {data.user_name}{" "}
        </p>
        <p>
          {data.age} years,{" "}
          <span className="newmatchescard_language">{data.mother_tongue}</span>
          <span className="newmatchescard_height">{data.height}</span>
        </p>
        <p style={{ lineHeight: "1.5" }}>{data.job_title}</p>
      </div>

      <button
        className="newmatchescard_connect_button"
        onClick={SendRequest}
        disabled={isRequestSent}
      >
        {isRequestSent ? "Request Sent" : "Connect Now"}
      </button>
      <ToastContainer />
    </div>
  );
};

export default NewMatchesCard;